import React from 'react';
import smallStarsImg from "../../images/background/small-stars.png";
import bigStarsImg from "../../images/background/big-stars.png";
import qaImg from "../../images/background/qa.png";
import jsImg from "../../images/background/js.png";
import autoImg from "../../images/background/auto.png";
import freeImg from "../../images/background/free.png";
import reactImg from "../../images/background/react.png";

const LessonBackground = ({ group, number }) => {

    const getImg = (group) => {
        if (group) {
            if (group.includes('QA')) return qaImg;
            if (group.includes('FREE')) return freeImg;
            if (group.includes('JS')) return jsImg;
            if (group.includes('REACT')) return reactImg;
            if (group.includes('AUTO')) return autoImg;
        } else {
            return ''
        }
    }

    if (number < 6) return null
    if (number === 6) {
        return <div style={{ marginTop: '3.75rem' }}>
            <img src={smallStarsImg} alt='smallStars' style={{ height: '11.2rem', width: '14.5rem' }} />
        </div>
    }
    if (number >= 7 && number <= 10) {
        return <div style={{ marginTop: '5rem' }}>
            <img src={getImg(group)} alt='group' style={{ height: '17.5rem', width: '17.5rem' }} />
        </div>
    }
    if (number >= 11 && number <= 12) {
        return <div>
            <div style={{ marginTop: '10rem' }}>
                <img src={getImg(group)} alt='group' style={{ height: '17.5rem', width: '17.5rem' }} />
            </div>
            <div style={{ marginTop: '5rem' }}>
                <img src={smallStarsImg} alt='smallStars' style={{ height: '11.2rem', width: '14.5rem' }} />
            </div>
        </div>
    }
    if (number >= 13) {
        return <div>
            <div style={{ marginTop: '10rem' }}>
                <img src={getImg(group)} alt='group' style={{ height: '17.5rem', width: '17.5rem' }} />
            </div>
            <div style={{ marginTop: '10rem' }}>
                <img src={bigStarsImg} alt='bigStars' style={{ height: '23.167rem', width: '23.111rem' }} />
            </div>
        </div>
    }
}

export default LessonBackground